import React, { useState } from "react";
import "./App.css";
import Camera from "./components/Camera";
import { identifyUser } from "./services/api";

function App() {
  // States: 'initial', 'scanning', 'processing', 'result'
  const [viewState, setViewState] = useState('initial');
  const [appState, setAppState] = useState({
    ui: {
      title: "Bienvenido",
      subtitle: "Pulsa escanear para comenzar",
    },
    // Default assets
    assets: {
      personImg: "/assets/ana_caregiver.png", // Will be replaced or hidden initially
      roomImg: "/assets/physio_room.png"
    }
  });

  const enterScanMode = () => {
    setViewState('scanning');
  };

  const cancelScan = () => {
    setViewState('initial');
  };

  const handleCapture = async (base64Image) => {
    setViewState('processing');
    try {
      // Call n8n webhook
      const response = await identifyUser(base64Image);

      console.log("n8n response:", response);

      // Check success based on n8n response structure (based on Toni - Ateneu App.json)
      // The webhook returns an array with a json object. Axios returns data.
      // If response matches our expected schema:
      if (response && (response.success || response.status === 'user_found')) {
        setAppState({
          ...response, // Merge webhook response (currentContext, ui, etc.)
          assets: {
            personImg: "/assets/ana_caregiver.png",
            personName: "Ana",
            roomImg: "/assets/physio_room.png",
            roomName: "Sala",
            ...(response.assets || {}) // Allow webhook to override assets
          }
        });
        setViewState('result');

        // Speak the message
        const msg = response.message || `${response.ui.title}. ${response.ui.subtitle}`;
        speakMessage(msg);

      } else {
        const errorMsg = response?.message ||
          (typeof response === 'string' ? response : "No se ha reconocido a nadie. Inténtalo de nuevo.");
        alert(errorMsg);
        setViewState('scanning');
      }

    } catch (error) {
      console.error(error);
      alert("Error de conexión. Revisa la consola.");
      setViewState('initial');
    }
  };

  const speakMessage = (msg) => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(msg);
      utterance.lang = "es-ES";
      window.speechSynthesis.speak(utterance);
    }
  };

  const resetFlow = () => {
    setViewState('initial');
    setAppState({
      ui: { title: "Bienvenido", subtitle: "Pulsa escanear para comenzar" },
      assets: {
        personImg: "/assets/ana_caregiver.png",
        personName: "Ana",
        roomImg: "/assets/physio_room.png",
        roomName: "Sala"
      }
    });
  };

  // Renders by State
  if (viewState === 'scanning') {
    return (
      <div className="app-container">
        <h1>Identificación</h1>
        <Camera onCapture={handleCapture} onCancel={cancelScan} />
      </div>
    );
  }

  if (viewState === 'processing') {
    return (
      <div className="app-container">
        <div className="loading-spinner"></div>
        <h2>Identificando usuario...</h2>
      </div>
    );
  }

  if (viewState === 'result') {
    return (
      <div className="app-container">
        <div className="greeting-card">
          <h1 className="greeting-title">
            {appState.ui.title}
          </h1>
          <div className="time-display">
            {appState.currentContext ? `Son las ${appState.currentContext.time}` : ''}
          </div>
          <div className="task-display">
            {appState.currentContext?.statusInfo || appState.ui.subtitle}
          </div>
        </div>

        {appState.status === 'user_found' && (
          <div className="visual-context">
            {/* Logic to show caregiver/room only if relevant info exists */}
            <div className="context-card">
              <img
                src={appState.assets.personImg}
                alt="Caregiver"
                className="context-image"
                onError={(e) => { e.target.style.display = 'none' }}
              />
              <p className="context-label">{appState.assets.personName}</p>
            </div>
            <div className="context-card">
              <img
                src={appState.assets.roomImg}
                alt="Room"
                className="context-image"
                onError={(e) => { e.target.style.display = 'none' }}
              />
              <p className="context-label">{appState.assets.roomName}</p>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem', justifyContent: 'center' }}>
          <button onClick={enterScanMode} className="result-action-btn primary">
            🔄 Escanear de nuevo
          </button>
          <button onClick={resetFlow} className="result-action-btn secondary">
            Salir / Terminar
          </button>
        </div>
      </div>
    );
  }

  // Initial State
  return (
    <div className="app-container">
      <div className="greeting-card">
        <h1 className="greeting-title">Bienvenido</h1>
        <p style={{ fontSize: '1.5rem', color: '#666' }}>Sistema de Asistencia Inteligente</p>
      </div>

      <button onClick={enterScanMode} className="start-button">
        📸 Escanear Cara
      </button>
    </div>
  );
}

export default App;
